import { Button } from '@headlessui/react'

interface IActionButtonProps {
    label: string
    type?: 'button' | 'submit' | 'reset'
    onClick?: () => void
}

export const BlackActionButton = (props: IActionButtonProps) => {
  return (
    <Button
      type={props.type || 'button'}
      onClick={props.onClick}
      className={
        'inline-flex items-center justify-center rounded-md bg-black p-3 text-base text-white data-focus:outline-white data-hover:bg-gray-800 cursor-pointer min-w-[60px]'
      }
    >
      {props.label}
    </Button>
  )
}
